module.exports = __webpack_public_path__ + "img/linkxr.b5a8ba8b.png";